// extracted by mini-css-extract-plugin
export default {"title":"_10c091ff"};